import { computed, Ref, ref } from 'vue'
import { DataTableFilter } from '@/types/DataTable'

interface PaymentMethodFilterPayload {
  label: string
  field: string
  multiple?: boolean
}

export function usePaymentMethodFilter({ label, field, multiple }: PaymentMethodFilterPayload): DataTableFilter<string> {
  const model: Ref<string | null> = ref('')

  const loading = ref(false)

  const ready = Promise.resolve(true)

  return {
    model,
    value: computed(() => model.value),
    items: computed(
      () => ([
        { title: 'Todos', value: '' },
        { title: 'Boleto', value: '2' },
        { title: 'Cartão de Crédito', value: '1' },
        { title: 'Cartão de Débito', value: '4' },
        { title: 'Débito Online', value: '3' },
        { title: 'Dinheiro', value: '8' },
        { title: 'Gratuito', value: '6' },
        { title: 'PIX', value: '5' },
        { title: 'Valor Isento', value: '7' },
      ]),
    ),
    label,
    field,
    type: 'select',
    loading,
    multiple,
    required: false,
    ready,
  }
}
